module.exports = __webpack_public_path__ + "img/41-image-1-1@2x.f1363f0c.png";